"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const DeferredPromiseExecutor_1 = require("./DeferredPromiseExecutor");
const index_1 = require("../index");
const DMSIPCMethod_1 = require("../enums/DMSIPCMethod");
const DMSErrorCode_1 = require("../enums/DMSErrorCode");
class DMSMessageHandler {
    //region Public Constructor
    constructor(server) {
        this.callables = {};
        //endregion
        //region Public Methods
        this.registerCallable = (method, callable) => {
            //console.log(`registering a callable for method: '${method}'`);
            const registeredCallable = this.callables[method];
            if (registeredCallable) {
                throw new Error("already has a callable for method: " + method);
            }
            this.callables[method] = callable;
        };
        this.removeAllCallables = () => {
            this.callables = {};
        };
        this.failIncomingMessage = (message, sender, error) => __awaiter(this, void 0, void 0, function* () {
            if (!this.server) {
                throw new Error("Only supported on dms_server!");
            }
            // check if the incoming message is deferred and is waiting to be fulfilled or rejected.
            const isDeferred = message.id && this.deferredPromiseExecutor.hasHandlers(message.id);
            if (isDeferred) {
                //should never happen here
                console.log("unhandled");
            }
            const errorMessage = index_1.DMSMessageFactory.createReply(message);
            errorMessage.error = error;
            yield this.send(errorMessage, sender, false);
        });
        this.processIncomingMessage = (message, sender) => __awaiter(this, void 0, void 0, function* () {
            // check if the incoming message is deferred and is waiting to be fulfilled or rejected.
            const isDeferred = message.id && this.deferredPromiseExecutor.hasHandlers(message.id);
            if (this.server) {
                if (isDeferred) {
                    console.log(`${message.id ? "⬅" : "⚡"}️️ client node '${sender.uid}' @ '${sender.remoteIp}' sent a reply": id:'${message.id}' method:'${message.method}'`);
                }
                else {
                }
            }
            else {
                console.log(`${message.id ? "⬅" : "⚡"}️️️ server sent a ${message.id ? "message" : "notification"}: id:'${message.id}' method:'${message.method}'`);
            }
            // the message is to be sent to an external node
            if (message.targetNode) {
                console.log("received a message that is to be executed on: " + message.targetNode);
                if (!this.server) {
                    console.error("messages can only be routed by the server!");
                    return;
                }
                // execute on the target node
                try {
                    message.sender = sender.uid;
                    const remoteResponse = yield this.sendMessageToRemoteNode(message.targetNode, message);
                    remoteResponse.method = undefined;
                    yield this.send(remoteResponse, sender, false);
                }
                catch (e) {
                    const errorMessage = index_1.DMSMessageFactory.createReply(message);
                    errorMessage.error = { code: DMSErrorCode_1.default.unknown_error, description: e.toString() };
                    yield this.send(errorMessage, sender, false);
                }
                return;
            }
            if (message.method) {
                const callable = this.callables[message.method];
                if (!callable) {
                    console.warn(`no callable registered for method '${message.method} isDeferred: ${isDeferred}'`);
                    if (isDeferred) {
                        this.deferredPromiseExecutor.ignore(message.id);
                    }
                    return;
                }
                const validates = this.validateMessage(message);
                if (!validates) {
                    console.error("could not validate the incoming message");
                    if (isDeferred) {
                        this.deferredPromiseExecutor.ignore(message.id);
                    }
                    if (this.server) {
                        throw new index_1.DMSError(DMSErrorCode_1.default.malformed_payload, "validation failed, malformed payload");
                    }
                    return;
                }
                let error;
                let result;
                try {
                    // execute the message
                    result = yield callable.implementation(message, sender);
                }
                catch (e) {
                    error = e;
                }
                // we do not reply to notifications
                if (message.id) {
                    // send the result back to callee
                    const replyMessage = index_1.DMSMessageFactory.createReply(message, result);
                    if (error) {
                        replyMessage.error = error;
                    }
                    this.send(replyMessage, sender, false);
                }
            }
            if (!isDeferred) {
                // the message is not a response to a deferred promise, no need to proceed further.
                return false;
            }
            if (message.error) {
                yield this.deferredPromiseExecutor.reject(message.id, message.error);
            }
            else {
                yield this.deferredPromiseExecutor.resolve(message.id, message.payload);
            }
            return true;
        });
        this.send = (message, receiver, awaitResponse = true) => {
            let promise;
            try {
                const json = this.serialize(message);
                if (message.id) {
                    if (awaitResponse) {
                        promise = this.deferredPromiseExecutor.defer(message.id);
                    }
                    if (this.server) {
                        console.log(`➡️ ${message.method ? "sending" : "replying with"} message: id:'${message.id}' method:'${message.method}' to client node '${receiver.uid}' @ '${receiver.remoteIp}' awaitingResponse:'${awaitResponse}'`);
                    }
                    else {
                        console.log(`➡️ ${message.method ? "sending" : "replying with"} message: id:'${message.id}' method:'${message.method}' to server awaitingResponse:'${awaitResponse}'`);
                    }
                }
                else {
                    if (this.server) {
                        console.log(`➡️ sending notification: ${json} to client node '${receiver.uid}' @ '${receiver.remoteIp}'`);
                    }
                    else {
                        console.log(`➡️ sending notification: ${json} to server'`);
                    }
                }
                receiver.send(json, { binary: false });
            }
            catch (err) {
                console.error("could not send a message to client: ", err);
            }
            return promise;
        };
        this.serialize = (message) => {
            return JSON.stringify(message);
        };
        this.deserialize = (json) => {
            return JSON.parse(json);
        };
        //endregion
        //region Private Methods
        this.validateMessage = (message) => {
            var _a, _b, _c;
            try {
                if (!message.id) {
                    return true;
                }
                if (!message.method) {
                    return false;
                }
                const registeredCallable = this.callables[message.method];
                if (registeredCallable && registeredCallable.parameters) {
                    for (const paramDeclaration of registeredCallable.parameters) {
                        const messageParam = message.payload[paramDeclaration.name];
                        // validate the param against the metadata
                        const paramType = typeof messageParam;
                        if (paramType !== paramDeclaration.type) {
                            console.error(`validation failed for message: ${JSON.stringify(message)} expected ${paramDeclaration.name} to be ${paramDeclaration.type}, but got ${paramType}`);
                            return false;
                        }
                    }
                }
                else if (message.payload && ((_a = registeredCallable.parameters) === null || _a === void 0 ? void 0 : _a.length) !== Object.keys(message.payload).length) {
                    console.error(`validation failed for message: ${JSON.stringify(message)} expected ${(_c = (_b = registeredCallable.parameters) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0} parameters, but got ${Object.keys(message.payload).length}`);
                    return false;
                }
                return true;
            }
            catch (error) {
                // ...
            }
            return false;
        };
        this.sendMessageToRemoteNode = (nodeName, message) => __awaiter(this, void 0, void 0, function* () {
            const reply = { id: message.id, method: message.method };
            try {
                // get the target node
                const targetNode = this.server.getNodeByName(nodeName);
                if (!targetNode && this.server) {
                    // the target node is not connected to this server, notify the master so that it can check its workers.
                    reply.payload = yield this.server.clusterController.sendToMaster({
                        id: index_1.Util.generateNewId(),
                        method: DMSIPCMethod_1.default.EXECUTE_ON_WORKER,
                        targetNode: nodeName,
                        payload: message
                    }, true);
                }
                else if (targetNode) {
                    message.targetNode = undefined;
                    message.id = index_1.Util.generateNewId();
                    reply.payload = yield this.send(message, targetNode, true);
                }
                else {
                    throw new Error("unhandled fatal error");
                }
            }
            catch (error) {
                const dmsError = error;
                if (dmsError.code !== undefined && dmsError.description) {
                    reply.error = dmsError;
                }
                else {
                    reply.error = { description: error.toString(), code: DMSErrorCode_1.default.unknown_error };
                }
            }
            return reply;
        });
        this.deferredPromiseExecutor = new DeferredPromiseExecutor_1.default(60000);
        this.server = server;
    }
}
exports.default = DMSMessageHandler;
//# sourceMappingURL=DMSMessageHandler.js.map